import React, { useContext, useEffect, useState } from 'react'
import './PaymentStatus.css'
import { FiCheckCircle } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import { CartContext } from '../../Hooks/CartContext'

export default function PaymentStatus() {
  const [code, setCode] = useState();
  const location = useLocation();
  const [statusPayment, setStatusPayment] = useState(false);
  const {addToCart} = useContext(CartContext);

  useEffect(() => {
    if (location.search != '') {
      let status = location.search.split('=')[2] == "OK" ? true : false;
      setStatusPayment(status)
      axiosConfig.get(`PayCallback?authority=${location.search.split('=')[1].split('&')[0]}&status=${status}`).then((res) => {
        setCode(res.data.message)
        addToCart(0)
      }).catch((res) => {

      })
    }
  }, [location.search])
  return (
    <div className='payment-wrapper'>
      <div className='paymentStatus-box'>
        <FiCheckCircle style={statusPayment ? {} : { color: 'red' }} />
        <h1>{statusPayment ? 'پرداخت موفقیت آمیز بود' : 'پرداخت ناموفق بود'}</h1>
        {
          statusPayment ? (
            <div>
              کد پیگیری شما : {code}
            </div>
          ) : (<></>)
        }
        <button>
          <Link to='/'>
            صفحه اصلی
          </Link>
        </button>
      </div>
    </div>

  )
}
